class ProductHeader {
  constructor(element) {
    if (!(element instanceof HTMLElement)) {
      throw new TypeError('Invalid element');
    }

    this.element = element;
    this.navigationOffset = -100;

    // getting all anchor links that are linking within the same document
    this.anchors = element.querySelectorAll('a[href^="#"]');

    this.anchors.forEach((anchor) => {
      anchor.addEventListener('click', (e) => {
        e.preventDefault();
        const maybeTarget = document.querySelector(anchor.getAttribute('href'));
        anchor.classList.add('active');
        anchor.classList.remove('inactive');

        if (maybeTarget) {
          window.scrollTo(0, maybeTarget.offsetTop + this.navigationOffset);
        }
        this.anchors.forEach((otherAnchor) => {
          if (otherAnchor !== anchor) {
            otherAnchor.classList.remove('active');
            otherAnchor.classList.add('inactive');
          }
        });
      });
    });
  }
}

export default ProductHeader;
